import script from "./ContactPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactPop.vue?vue&type=script&setup=true&lang=ts"

import "./ContactPop.vue?vue&type=style&index=0&id=160aeb4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160aeb4a"]])

export default __exports__